(function () {
  'use strict';

  var REVIEWS = [
    { n: 'Fiza',     t: "The fabric is really too good to wear. Honestly I'm a fan of your material. When I wear it, it felt too smooth and clean. It's so much best when you're working out because it is so comfortable." },
    { n: 'Mubariz',  t: 'Breathable, lightweight, and very comfortably stretchable \u2014 the fabric feels great and makes it easy to move around all day.' },
    { n: 'Fizza',    t: 'The fabric quality is good, also comfortable and breathable. Must buy!!' },
    { n: 'Abdullah', t: 'Quality is super fantastic and the fabric was really smooth and stretchable.' },
    { n: 'Taha',     t: 'Quality is good, amazing stuff. The fabric is breathable and stretchable. I will definitely recommend it to others.' },
    { n: 'Samra',    t: 'Perfect for summer. Affordable, super comfortable and stretchy fabric. Garmi ke liye best hai yaar! Fabric bohot light, stretchy aur comfortable hai.' },
    { n: 'Usman',    t: 'Overall, quality is good. Really comfortable to wear and looks great too.' },
    { n: 'Ahsan',    t: "Yes it's good and the fabric was comfortable." },
    { n: 'Shayan',   t: 'The fabric is good, but the quality needs a little improvement.', s: '8/10' },
    { n: 'Xhezi',    t: 'Acha hai, bas mere size thora sa tight tha. Fabric acha hai aur stretch bhi.' }
  ];

  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
  var DELAY = 4200;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function isProductPage() {
    return document.body.classList.contains('template-product') ||
           /\/products\//.test(window.location.pathname);
  }

  /* Prefer inserting straight after the main product section, so the reviews sit
     directly under the product rather than after related-products blocks. */
  function anchor() {
    var btns = document.querySelector('.t4s-product-form__buttons');
    var sec = btns && btns.closest ? btns.closest('.shopify-section') : null;
    if (sec && sec.parentNode && !sec.closest('.t4s-drawer, .mfp-content, .t4s-quickview')) {
      return { parent: sec.parentNode, before: sec.nextSibling };
    }
    var main = document.getElementById('MainContent');
    if (main) return { parent: main, before: null };
    return null;
  }

  function card(r) {
    return '<article class="op-review">' +
      '<p class="op-review__mark" aria-hidden="true">\u201C</p>' +
      '<p class="op-review__quote">' + esc(r.t) + '</p>' +
      '<div class="op-review__foot">' +
        '<span class="op-review__avatar" aria-hidden="true">' + esc(r.n.charAt(0)) + '</span>' +
        '<span>' +
          '<span class="op-review__name">' + esc(r.n) + '</span>' +
          '<span class="op-review__tag">' + TICK + 'Verified customer</span>' +
        '</span>' +
        (r.s ? '<span class="op-review__score">' + esc(r.s) + '</span>' : '') +
      '</div>' +
    '</article>';
  }

  function build() {
    if (!isProductPage()) return;
    if (document.querySelector('.op-reviews')) return;
    var at = anchor();
    if (!at) return;

    var sec = document.createElement('section');
    sec.className = 'op-reviews';
    sec.setAttribute('aria-label', 'Customer reviews');
    sec.innerHTML =
      '<div class="op-reviews__head">' +
        '<div>' +
          '<h2 class="op-reviews__title">What our customers say</h2>' +
          '<p class="op-reviews__sub">Real feedback from Outphic customers</p>' +
        '</div>' +
        '<div class="op-reviews__nav">' +
          '<button type="button" class="op-reviews__btn" data-op-prev aria-label="Previous reviews" style="transform:rotate(180deg)">' + ARROW + '</button>' +
          '<button type="button" class="op-reviews__btn" data-op-next aria-label="Next reviews">' + ARROW + '</button>' +
        '</div>' +
      '</div>' +
      '<div class="op-reviews__track" data-op-track>' + REVIEWS.map(card).join('') + '</div>';

    at.parent.insertBefore(sec, at.before);

    var track = sec.querySelector('[data-op-track]');
    var prev = sec.querySelector('[data-op-prev]');
    var next = sec.querySelector('[data-op-next]');
    var timer = null, paused = false;

    function step() {
      var c = track.querySelector('.op-review');
      return c ? c.offsetWidth + 18 : 340;
    }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 8; }
    function sync() { prev.disabled = track.scrollLeft < 8; next.disabled = atEnd(); }
    function advance() { atEnd() ? (track.scrollLeft = 0) : (track.scrollLeft += step()); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { if (!paused) advance(); }, DELAY);
    }

    prev.addEventListener('click', function () { track.scrollLeft -= step(); start(); });
    next.addEventListener('click', function () { advance(); start(); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sec.addEventListener('mouseenter', function () { paused = true; });
    sec.addEventListener('mouseleave', function () { paused = false; });
    sec.addEventListener('focusin', function () { paused = true; });
    sec.addEventListener('focusout', function () { paused = false; });
    track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 6000); }, { passive: true });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.2 }).observe(sec);
    } else { start(); }

    sync();
  }

  function boot() {
    build();
    /* retry briefly in case the product section renders late */
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      build();
      if (tries > 12 || document.querySelector('.op-reviews')) clearInterval(iv);
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  /* rebuild after instant-page / history navigation */
  window.addEventListener('pageshow', boot);
  window.addEventListener('popstate', function () { setTimeout(boot, 300); });
})();
